import { ChangeEvent } from 'react'

import { ButtonRebrand } from 'src/components/atoms/ButtonRebrand'

import { ParamValue, Params } from 'src/hooks/useFilters'

interface Filter {
  id: string
  title: string
  options: FilterOption[]
  hideAllOption?: boolean
}

interface FilterOption {
  id: string
  name: string
}

export interface FilterControlsProps {
  filters: Filter[]
  onChange: (newFilters: Params) => void
  onClear: () => void
  selectedFilters: { [key: string]: ParamValue | null }
  showOnClear?: boolean
}

const CLEAR_VALUE = 'CLEAR'

export const FilterControls = ({
  filters,
  onChange,
  onClear,
  selectedFilters,
  showOnClear = true
}: FilterControlsProps) => {
  function handleChangeFilter(filterId: string, filterValue: string) {
    onChange({ [filterId]: filterValue })
  }

  return filters.length ? (
    <div className='flex items-stretch space-x-2'>
      {filters.map((filter: Filter) => (
        <div className='items-center w-full' key={filter.id}>
          <label className='font-bold mr-2' htmlFor={filter.id}>
            {filter.title}:
          </label>
          <div className='form-input-wrapper mb-0'>
            <select
              className='ttc-form-input'
              id={filter.id}
              onChange={(e: ChangeEvent<HTMLSelectElement>) =>
                handleChangeFilter(filter.id, e.target.value)
              }
              // TODO: next/router allows both a string and an array of strings as a query param
              // but filter controls doesn't support that, so we should probably handle this at some point
              value={selectedFilters?.[filter.id] || CLEAR_VALUE}
            >
              {filter.hideAllOption ? null : (
                <option value={CLEAR_VALUE}>See all</option>
              )}
              {filter.options.map((opt: FilterOption) => (
                <option
                  key={opt.id}
                  value={opt.id}
                  disabled={opt.id.indexOf('__') === 0}
                >
                  {opt.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      ))}
      {filters.length > 1 && showOnClear ? (
        <div className='flex items-end min-w-fit ml-2'>
          <ButtonRebrand
            variant='forest'
            disabled={!Object.values(selectedFilters).some(val => val !== null)}
            onClick={onClear}
          >
            Clear all filters
          </ButtonRebrand>
        </div>
      ) : null}
    </div>
  ) : null
}
